import { render, staticRenderFns } from "./AdwordsSummary.vue?vue&type=template&id=3e94cbb4&scoped=true&"
import script from "./AdwordsSummary.vue?vue&type=script&lang=js&"
export * from "./AdwordsSummary.vue?vue&type=script&lang=js&"
import style0 from "./AdwordsSummary.vue?vue&type=style&index=0&id=3e94cbb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e94cbb4",
  null
  
)

export default component.exports